import React from "react";
import { activeDialogState } from "../../redux/slices/dialogsSlice";
import { useSelector } from "react-redux";
import { GlobalVariables } from "../../GlobalVariables";

const ProgressDialog = () => {
    const currentActiveDialogState =  useSelector(activeDialogState);
    const [open, setOpen] = React.useState(false);

    React.useEffect(() => {
        setOpen(currentActiveDialogState === 'waitProgress');
    }, [currentActiveDialogState]);

    return (
        <div>
            {open && (
                <div className="hs-overlay fixed inset-0 z-[60] overflow-y-auto bg-gray-900/50 p-4">
                    <div className="mx-auto mt-10 max-w-xl">
                        <div className="relative grid grid-cols-1 overflow-hidden rounded-2xl bg-white shadow-xl ring-1 ring-gray-200 md:grid-cols-12">
                            <section className="col-span-12 mx-10 my-12">
                                <span className="text-xl font-medium">{GlobalVariables.dialogConfig.title}</span>
                                <p className="text-sm text-justify my-4">{GlobalVariables.dialogConfig.content}</p>
                            </section>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ProgressDialog;
